const Python = () => {
  return <h1>Python  </h1>;
};

export default Python;